import tippy from 'tippy.js';
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const BM = editor.BlockManager;
    const COMMANDS = editor.Commands;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    var model = MODEL.extend({
        defaults:{
            ...MODEL.prototype.defaults,
            tagName:'div',
            droppable: false, 
            components: [
                {
                  tagName: 'select',
                  attributes:{ 
                    name: "gender"
                  },
                  classes:['form-control'],
                  components: [
                    {
                      tagName: 'option',
                      attributes:{ value: "H" },
                      content: "Sr"
                    },
                    {
                      tagName: 'option',
                      attributes:{ value: "W" },
                      content: "Sra"
                    } 
                  ]
      
                }
            ]
        }
        
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-GENDER-SELECT")
                return { type:'C-GENDER-SELECT' }
        }
    });

    DOMC.addType('C-GENDER-SELECT',{
      model: model,
      view: VIEW
    });

};
  